<ui-card padding="md" data-testid="wishlist-detail-item-row">
  <article
    class="wishlist-item-row"
    [class.guest-row]="isGuestRow()"
    [attr.aria-label]="rowAccessibleLabel()"
  >
    <div class="item-main">
      <span class="item-anchor" aria-hidden="true">
        <ui-library-icon name="other" fallbackLabel="Prezent" />
      </span>

      <div class="item-content">
        <div class="title-line">
          <h3 class="item-title">{{ row().title }}</h3>
          @if (hasActions()) {
            <ui-action-menu
              [ariaLabel]="'Więcej akcji dla ' + row().title"
              triggerLabel="⋯"
              [items]="actionMenuItems()"
              (itemSelected)="handleActionIdSelected($event)"
            />
          }
        </div>

        @if (hasDescription()) {
          <p class="item-description">
            {{ row().description }}
          </p>
        }

        <div class="item-meta">
          <wishlist-status-pill
            [label]="row().statusLabel"
            [tone]="row().statusTone"
            [ariaLabel]="statusAccessibleLabel()"
          />
          @if (hasPrice()) {
            <span>{{ row().priceLabel }}</span>
          }
          @if (hasPriority()) {
            <span>{{ row().priorityLabel }}</span>
          }
          @if (showShopLink()) {
            <a
              [href]="row().shopUrl"
              target="_blank"
              rel="noreferrer"
              [attr.aria-label]="shopLinkLabel()"
              >Sklep</a
            >
          }
        </div>

        @if (hasReservationLines()) {
          <div
            class="item-reservation"
            [class.item-reservation-warning]="isReservationWarning()"
          >
            @if (hasReservationEmail()) {
              <div class="item-email">
                {{ row().reservationEmail }}
              </div>
            }
            @for (line of row().reservationLines; track line) {
              <div>{{ line }}</div>
            }
          </div>
        }
      </div>
    </div>

    <div class="item-actions">
      @if (row().canReserve) {
        <ui-button size="sm" (pressed)="handleReserveSelected()"
          >Rezerwuję zakup</ui-button
        >
      } @else if (row().reserveDisabledReason) {
        <span class="item-disabled">{{ row().reserveDisabledReason }}</span>
      }
    </div>
  </article>
</ui-card>
